import { useMutation } from '@tanstack/react-query'
import { deleteCustomIssueFilter } from '@/routes/projectStages/issues/lib/actions/issuesActions.ts'
import { MouseEvent } from 'react'
import LoadingIndicator from '@/components/common/LoadingIndicator.tsx'
import { usePropertiesStore } from '@/components/common/propertyPopoverOverlay/usePropertiesStore.ts'
import { Trash2 } from 'lucide-react'

type PropsT = { id?: string }

export default function IssuesFiltersDeleteCustomFilterBtn({ id }: PropsT) {
  const addDeletedFilterId = usePropertiesStore(state => state.addDeletedPropertiesId)
  const { mutateAsync: deleteCustomFilter, isPending } = useMutation({
    mutationFn: deleteCustomIssueFilter,
    onSuccess: () => addDeletedFilterId(id as string),
  })

  async function handleClick(e: MouseEvent<HTMLButtonElement>) {
    if (!id) return
    e.stopPropagation()
    await deleteCustomFilter(id)
  }

  return (
    <>
      <button onClick={e => handleClick(e)}>
        {isPending ? <LoadingIndicator /> : <Trash2 className={`size-4`} />}
      </button>
    </>
  )
}
